// Configuration file for API endpoints

const config = {
  // For local testing, use localhost backend
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  API_JS_URL: process.env.REACT_APP_API_JS_URL,
};

export default config; 